import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const LanguageSelector = () => {
    const { i18n, t } = useTranslation();

    const languages = [
        { code: 'es', name: t('languages.es'), flag: '🇪🇸' },
        { code: 'en', name: t('languages.en'), flag: '🇬🇧' },
        { code: 'pt', name: t('languages.pt'), flag: '🇵🇹' },
        { code: 'fr', name: t('languages.fr'), flag: '🇫🇷' },
        { code: 'de', name: t('languages.de'), flag: '🇩🇪' },
    ];

    const handleLanguageChange = (languageCode) => {
        i18n.changeLanguage(languageCode);
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {languages.map((language) => (
                <Tooltip key={language.code} title={language.name}>
                    <Button
                        variant={i18n.language === language.code ? 'contained' : 'outlined'}
                        onClick={() => handleLanguageChange(language.code)}
                        sx={{ minWidth: 0, padding: '6px' }}
                    >
                        <span style={{ fontSize: 24 }}>{language.flag}</span>
                        {i18n.language === language.code && <CheckIcon sx={{ fontSize: 16, ml: 0.5 }} />}
                    </Button>
                </Tooltip>
            ))}
        </Box>
    );
};

export default LanguageSelector;
